/* eslint-disable react/state-in-constructor */
import { CONSULT_TYPE_CHAT } from 'Constants/consults';
import { arrayOf, func, shape } from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import { clearEntities } from 'Redux/modules/entities/actions';
import * as Actions from 'Redux/modules/webChat/actions';
import { getConsultsHistory, getConversationById } from 'Selectors/webChat/consults';
import { Icon, Segment } from 'semantic-ui-react';

import ContextMenuHeader from '../ContextMenuHeader';

import ConsultDetails from './ConsultDetails';
import ConsultItem from './ConsultItem';
import { HISTORY_DETAILS, HISTORY_LIST, HISTORY_SUMMARY } from './ContentType';
import ConsultSummary from './Summary/Summary';

const PAGE_SIZE = 20;

class ConsultHistory extends Component {
  state = {
    type: HISTORY_LIST,
    consult: {},
  };

  componentDidMount() {
    this.getConsultHistory({ consulType: CONSULT_TYPE_CHAT, pageSize: PAGE_SIZE });
  }

  getConsultHistory = (params = {}) => {
    const { getConsultHistory, conversation } = this.props;
    getConsultHistory(conversation.id, params);
  };

  handleLoadMoreConsult = () => {
    const {
      getConsultHistory,
      consultHistory,
      conversation: { id },
    } = this.props;
    const {
      status: { loading },
      meta: {
        pagination: { page, pages },
      },
    } = consultHistory;
    if (loading !== 0 && page < pages) {
      getConsultHistory(id, {
        page: page + 1,
        consulType: CONSULT_TYPE_CHAT,
        pageSize: PAGE_SIZE,
      });
    }
  };

  goToMenu = (consult, type) => {
    this.setState({
      type,
      consult,
    });
  };

  goBackHistory = () => {
    this.setState({
      type: HISTORY_LIST,
    });
  };

  render() {
    const { type, consult } = this.state;
    const { closeContextMenu, consultHistory, conversation, consultHistoryList, doctor } =
      this.props;
    const {
      status,
      meta: {
        pagination: { page, pages },
      },
    } = consultHistory;
    const next = page < pages;
    const {
      latestConsult: { patient, forPatient },
    } = conversation;
    const isLoading = status.loading === 0 && consultHistoryList.length === 0;
    return (
      <>
        <Segment.Group
          className="context-menu"
          style={type === HISTORY_LIST ? {} : { display: 'none' }}>
          <ContextMenuHeader title="Consult history" goBack={closeContextMenu} />
          <Segment className="body consult-history" loading={isLoading}>
            {consultHistoryList.map(item => (
              <ConsultItem
                key={item.id}
                consult={item}
                getMessageGoToTime={this.getMessageGoToTime}
                goToMenu={this.goToMenu}
              />
            ))}
            {next && (
              <Waypoint onEnter={this.handleLoadMoreConsult}>
                <div className="text-center">
                  <Icon name="spinner" loading size="big" />
                </div>
              </Waypoint>
            )}
          </Segment>
        </Segment.Group>
        {type === HISTORY_DETAILS && (
          <ConsultDetails
            goBack={this.goBackHistory}
            consult={consult}
            patient={patient}
            forPatient={forPatient}
          />
        )}
        {type === HISTORY_SUMMARY && (
          <ConsultSummary goBack={this.goBackHistory} consult={consult} doctor={doctor.data} />
        )}
      </>
    );
  }
}

ConsultHistory.propTypes = {
  getConsultHistory: func.isRequired,
  closeContextMenu: func.isRequired,
  conversation: shape({}).isRequired,
  doctor: shape({}).isRequired,
  consultHistory: shape({}).isRequired,
  consultHistoryList: arrayOf(shape({})).isRequired,
};

ConsultHistory.defaultProps = {};

const mapStateToProps = state => ({
  consultHistoryList: getConsultsHistory(state),
  conversationActive: getConversationById(state, state.webChat.conversationActive),
  consultHistory: state.webChat.consultHistory,
  doctor: state.webChat.doctor,
});

const mapDispatchToProps = {
  getConsultHistory: Actions.consultHistoryRetrieve,
  clearMessages: Actions.messagesClear,
  getMessageGoToTime: Actions.getMessageGoToTime,
  clearEntities,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsultHistory);
